const autoNgTemplateLoaderTemplate1 = require('./access-viewer.html');

import controller from './access-viewer.controller';

export const accessViewer = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
